import React, { useContext,useRef, useEffect, useState,useCallback } from "react";
import { alpha } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import MenuIcon from "@mui/icons-material/Menu";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import SearchIcon from "@mui/icons-material/Search";
import Autocomplete, {
  createFilterOptions,
} from '@mui/material/Autocomplete';
import TextField from "@mui/material/TextField";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Badge from "@mui/material/Badge";
import InventoryReview from "./InventoryReview";
import InventoryInformation from "./InventoryInformation";
import Slide from "@mui/material/Slide";
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { AppContext } from "../../../Context/AppContext";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import {format,parseISO} from 'date-fns';
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import InputInventoryDialog from "./InputInventoryDialog";
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import LinearProgress from '@mui/material/LinearProgress';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import Stack from '@mui/material/Stack';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Papa from 'papaparse';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';


const drawerWidth = 300;

const materialTheme = createTheme(({
  // set default for now
}));
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },

  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  appBarBottom: {
    top: "auto",
    bottom: 0,
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  grow: {
    flexGrow: 1,
  },
  productListPaper: {
    marginBottom: 50,
  },
}));

const filter = createFilterOptions();

export default function RecordActualInvetory(props) {
  const inputedInventoryTag = "inputted_inventory";
  const classes = useStyles();
  const { companyId } = useContext(AppContext);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const openMenu = Boolean(menuAnchorEl);
  const [searchProductTerm, setSearchProductTerm] = useState({ name: "" });
  const [autoSuggestProducts, setAutoSuggestProducts] = useState([]);
  const [products, setProducts] = useState([]);
  const [openInventoryProductsReview, setOpenInventoryProductsReview] = useState(false);
  const [openReturnInformationReview, setOpenReturnInformationReview] = useState(false);
  const [openInventoryAddLotNumberAndExpiration,setOpenInventoryAddLotNumberAndExpiration] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState();
  const [productToDeleteInventory,setProductToDeleteInventory] = useState()
  const [inputtedInventoryToDelete,setInputtedInventoryToDelete] = useState()
  const [showDeleteConfirmationDialog,setShowDeleteConfirmationDialog] = useState(false)
  const [isLoading,setIsLoading] = useState(true)
  const [hasMoreProductToLoad,setHasMoreProductToLoad] = useState(true)
  const [pageNumber,setPageNumber] = useState(1)
  const [loadProducts,setLoadProducts] = useState(true)
  const [autoCompleteSearchOptionMessage,setAutoCompleteSearchOptionMessage] = useState("Searching...")
  const [showUploadInventoryDialog, setShowUploadInventoryDialog] = useState(false);
  const [csvFile, setCsvFile] = useState("");
  const [showInventoryDialog, setShowInventoryDialog] = useState(false);
  const [csvUploadPercent, setCsvUploadPercent] = useState(0);
  const [uploadStatusArray,setUploadStatusArray] = useState([])
  const [showUploadInventoryStatusDialog, setShowUploadInventoryStatusDialog] = useState(false);
  
  const [limitInventoryUpload, setLimitInventoryUpload] = useState(0);
 
  const inventoryInputDeleteClick = (product,inventory)=>(event)=>{
    setShowDeleteConfirmationDialog(true)
    setProductToDeleteInventory(product)
    setInputtedInventoryToDelete(inventory)
 

  }
  const deleteInventoryBtnClick = ()=>{
    const temporaryInventoryString = localStorage.getItem(companyId + "_temporary_inventory_count");
    if (temporaryInventoryString == null) {
    
      return;
    }

    const temporaryInventoryJSON = JSON.parse(temporaryInventoryString);
    const selectedProductInTempDataIndex = temporaryInventoryJSON.findIndex((productParam) => productParam.code == productToDeleteInventory.code);
    const selectedProductInTempData = temporaryInventoryJSON[selectedProductInTempDataIndex]
    const inputtedInventories = selectedProductInTempData.InputtedInventories
    const selectedInventoryIndex = inputtedInventories.findIndex((inventoryParams)=>{
      if(inventoryParams.uom == inputtedInventoryToDelete.uom && inventoryParams.expiration_date == inputtedInventoryToDelete.expiration_date && inventoryParams.lot_number == inputtedInventoryToDelete.lot_number && inventoryParams.quantity == inputtedInventoryToDelete.quantity ){
        return true
      }
      return false
    })
    // delete inputted inventory
    inputtedInventories.splice(selectedInventoryIndex,1) //remove object
    if(inputtedInventories.length <= 0){
      temporaryInventoryJSON.splice(selectedProductInTempDataIndex,1) //remove object
    }
    localStorage.setItem(companyId+ "_temporary_inventory_count",JSON.stringify(temporaryInventoryJSON))
    onProductInputtedInventory(selectedProductInTempData)
    setShowDeleteConfirmationDialog(false)



  }
  const onProductInputtedInventory = (product)=>{
    
    const productsCopy = [...products]
    const productIndex = productsCopy.findIndex((productParam) => productParam.code == product.code);
    if (productIndex >= 0) {
      productsCopy.splice(productIndex, 1, product); //replace object
    } 
    setProducts(productsCopy)

  }

  const lastProductElementObserver = useRef()
    const lastProductElement = useCallback(node=>{
     
      if(isLoading){
          return
      }
      if(lastProductElementObserver.current){
        lastProductElementObserver.current.disconnect()
      }
      
      lastProductElementObserver.current = new IntersectionObserver(entries=>{
        if(entries[0].isIntersecting && hasMoreProductToLoad){
         
          lastProductElementObserver.current.disconnect()
          setPageNumber(prevPageNumber => prevPageNumber + 1)
          setLoadProducts(true)
       
        }

      })
      
      if(node){
        lastProductElementObserver.current.observe(node)
      }
    })
    
  const menuHandleClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  function formatDate(dateString,formatPattern){
    try {
      return format(parseISO(dateString), formatPattern)
    }catch(err){
      return ""
    }
  }
  function totalProductCountWithInventoryInputted(){

    const temporaryInventoryString = localStorage.getItem(companyId + "_temporary_inventory_count");
    if (temporaryInventoryString == null) {
    
      return 0;
    }

    const temporaryInventoryJSON = JSON.parse(temporaryInventoryString);

    return temporaryInventoryJSON.length

  }
  function closeAllDialog() {
    setOpenInventoryProductsReview(false);
    setOpenReturnInformationReview(false);
  }
  
  function deleteInputtedInventoryConfirmationDialog(){

    if(!inputtedInventoryToDelete){
      return("")
    }
    return(
      <Dialog
      open={showDeleteConfirmationDialog}
      onClose={()=>{setShowDeleteConfirmationDialog(false)}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      >
      <DialogTitle id="alert-dialog-title">{"Are you sure to delete inventory data?"}</DialogTitle>
      <DialogContent>
       
          
          <div>
            {productToDeleteInventory.name}<br/>
            Quantity: {inputtedInventoryToDelete.quantity} {inputtedInventoryToDelete.uom}<br/>
            Lot #: {inputtedInventoryToDelete.lot_number}<br/>
            Expiration: {formatDate(inputtedInventoryToDelete.inputtedInventoryToDelete,'MMM. dd, yyyy')}
          </div>
          
        
      </DialogContent>
      <DialogActions>
        <Button onClick={()=>{setShowDeleteConfirmationDialog(false)}} color="primary">
          No
        </Button>
        <Button onClick={deleteInventoryBtnClick} color="primary" autoFocus>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
    )
  }
  function autoComplete() {
    return (
      <Autocomplete
        value={searchProductTerm}
        noOptionsText={autoCompleteSearchOptionMessage}
        onChange={(event, newValue) => {

          if(newValue==null || newValue.name===""){
            searchProductTerm.name = ""
            return
          }
          if(newValue==null || newValue.name===""){
            searchProductTerm.name = ""
            return
          }
          searchProductTerm.name = newValue.name
          setProducts([])
          setPageNumber(1)
          setLoadProducts(true)
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);

          return filtered;
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        options={autoSuggestProducts}
        getOptionLabel={(option) => {
             
          return option.name;
        }}
        renderOption={(option) => option.name}
        style={{ width: "100%", paddingLeft: "8px" }}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.name}>
              {option.name}
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField
            variant="standard"
            {...params}
            InputProps={{ ...params.InputProps, disableUnderline: true }}
            onChange={(event)=>{
              setSearchProductTerm({name:event.target.value})
            }}
          />
        )}
      />
    );
  }
  function search() {
    return (
      <div
        position="static"
        style={{
          border: ".1rem solid #989898",
          borderRadius: "4px",
          margin: "2px",
        }}
      >
        <Toolbar variant="dense" style={{ padding: "0" }}>
          <Box flexGrow={1}>{autoComplete()}</Box>
          <Box>
            <IconButton
              className={classes.margin}
              onClick={()=>{
                setProducts([])
                setPageNumber(1)
                setLoadProducts(true)
              }}
              size="large">
              <SearchIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </div>
    );
  }

  
  function productLists() {
  
    return (
      <List>
        {products.map((product,index) => (

          (products.length  === index + 1) ?
          (
          <React.Fragment key={product.id}>
            <ListItem ref={lastProductElement} >{productElement(product)}</ListItem>
            <Divider light />
          </React.Fragment>
          ):
          (
          <React.Fragment key={product.id}>
            <ListItem>{productElement(product)}</ListItem>
            <Divider light />
          </React.Fragment>
          
          )
        ))}
      </List>
    );
  }

  // function productLists() {
  
  //   return (
  //     <List>
  //       {products.map((product) => (
  //         <React.Fragment key={product.id}>
  //           <ListItem>{productElement(product)}</ListItem>
  //           <Divider light />
  //         </React.Fragment>
  //       ))}
  //     </List>
  //   );
  // }
  
  function renderInputedInventory(product){
    
    if(product.InputtedInventories){
      return (
        <List>
          {
             product.InputtedInventories.map((inventory,index)=>{
              return (
                <ListItem divider key={index}>
                  <ListItemText
                      primary={
                        <div>
                          Quantity : {inventory.quantity} {inventory.uom}<br/>
                          Lot # : {inventory.lot_number}<br/>
                          Expiration : {formatDate(inventory.expiration_date,'MMM. dd, yyyy')}
                        </div>
                      }
                    />
                     <ListItemSecondaryAction>
                      <IconButton
                        edge="end"
                        aria-label="delete"
                        onClick={inventoryInputDeleteClick(product,inventory)}
                        size="large">
                        <DeleteIcon />
                      </IconButton>
                    </ListItemSecondaryAction>
                </ListItem>
              );
              
             })
          }
        </List>
      );
     
    }
    return ""
    
  }
  function productElement(product) {
    return (
      <Card elevation={0} style={{ width: "100%" }}>
        <CardContent>
          <Grid container item>
            <Grid
              container
              direction="column"
              justifyContent="space-between"
              alignItems="stretch"
            >
              <Grid
                item
                container
              >
                <Grid item xs={4} md={3} lg={2} >
                    <img
                        width={100}
                        height={100}
                        src={product.image}
                        alt={product.name}
                        // src={URL.createObjectURL(props.selectedSalesOrder.image)}
                        loading="lazy"
                        onError={(event) => {
                            event.currentTarget.onerror = null; // prevents looping
                            event.currentTarget.src="https://transacti.tradynamics.com/img/no-image-available.jpg";
                        }}
                    />
                </Grid>

                <Grid item xs container direction="column">
                  <Box style={{ fontWeight: 600, fontSize: "14px" }}>
                    {product.brand}
                  </Box>
                  <Box style={{ fontWeight: 600, fontSize: "14px" }}>
                    {product.name}
                  </Box>
                </Grid>
              </Grid>
              <Grid item>
                {
                 renderInputedInventory(product)
                }
              </Grid>
              <Grid item container justifyContent="flex-end"></Grid>
            </Grid>
          </Grid>
        </CardContent>
        <CardActions>
          <Button
            variant="contained"
            color="primary"
            size="small"
            className={classes.button}
            startIcon={<AddIcon />}
            onClick={()=>{
              
              setSelectedProduct(product);
              setOpenInventoryAddLotNumberAndExpiration(true)
            
            }}
          >
            Input Inventory
          </Button>
        </CardActions>
      </Card>
    );
  }

  function generateSampleProductData() {
    var products = [];

    var product = {};
    product.image =
      "https://ph-live-05.slatic.net/p/02ec90d147dd03b2271d8588a5d5ba08.png_720x720q80.jpg_.webp";
    product.id = new Date().getTime() + Math.floor(Math.random() * 100);
    product.name = `Coca-Cola Zero Sugar 1.5L`;
    product.code = `code-1234`;
    product.barcode = `123459875454`;
    product.short_name = `Coca-Cola Zero Sugar1.5L`;
    product.description = `description`;
    product.brand = `Coca-cola`;
    product.total_order_value = 600;
    product.available_inventory = 1000;
    product.available_inventory_unit = "bottle";
    var units = [];
    for (var y = 0; y < 2; y++) {
      var unit = {};
      unit.id = y;
      unit.uom = y == 0 ? "bottles" : "case";
      unit.product_code = `code-1234`;
      unit.converted_to_smallest = y == 0 ? 1 : 12;
      unit.price_with_tax = y == 0 ? 60 : 720;
      unit.price_without_tax = 10.0;
      unit.order_quantity = 10;

      units.push(unit);
    }
    product.units = units;
    products.push(product);

    product.units = units;
    products.push(product);

    return products;
  }
  function underConstruction() {
    return (
      <h2>
        <center> Under construction</center>
      </h2>
    );
  }
  useEffect(()=>{
    if(openInventoryProductsReview){
      return
    }

    const productCopy = [...products]
    const temporaryInventoryString = localStorage.getItem(companyId+"_temporary_inventory_count");
    
     if (temporaryInventoryString == null) {
      productCopy.forEach((product,index)=>{
        product.InputtedInventories = []
       
      })
       setProducts(productCopy) 
       return;
     }

     const temporaryInventoryJSON = JSON.parse(temporaryInventoryString);
    
     productCopy.forEach((product,index)=>{
       product.InputtedInventories =  getInputtedInventories(product,temporaryInventoryJSON)
      
     })
     setProducts(productCopy);


  },[openInventoryProductsReview])


  useEffect(() => {
    if(!loadProducts){
      return;
    }
   
    
    fetchProducts(searchProductTerm.name);
    
  }, [loadProducts]);
  
  
  useEffect(()=>{

    fetchAutoSuggestProducts(searchProductTerm.name)

  },[searchProductTerm])


  function fetchProducts(searchTerm) {

    
    setIsLoading(true)

    var formData = new FormData(); // Currently empty
    formData.append("search_term", searchTerm)
    formData.append("page_number",pageNumber)
    const options = {
      method: "POST",
      url: "/TransactiSellerProducts/getTransatiLiteProductsForStockAudit.json",
      data: formData,
    };
    axios(options)
      .then((res) => {
          setLoadProducts(false)
          setIsLoading(false)
          const isSuccess = res.data.response.is_success;

        if (!isSuccess) {
          alert("Error encounter")

          // setIsSavingSuccess(false)
          // setIsSavingAccount(false)
          // setMessageDialogMessage(res.data.response.message)
          // setShowMessageDialog(true)

          return;
        }

        const productFromServer = res.data.response.products;  
        const temporaryInventoryString = localStorage.getItem(companyId+"_temporary_inventory_count");
        
        setHasMoreProductToLoad(productFromServer.length > 0)

        if (temporaryInventoryString == null) {
         setProducts(products.concat(productFromServer))
          return;
        }

        const temporaryInventoryJSON = JSON.parse(temporaryInventoryString);
       
        productFromServer.forEach((product,index)=>{
          product.InputtedInventories =  getInputtedInventories(product,temporaryInventoryJSON)
         
        })

        setProducts(products.concat(productFromServer))

      })
      .catch((error) => {
        setLoadProducts(false)
        setIsLoading(false)
        console.log(error);
      });
  }


  function fetchAutoSuggestProducts(searchString){
  

    const loadProducts = async () => {
        
      setAutoCompleteSearchOptionMessage("Searching")

        var formData = new FormData(); // Currently empty
        formData.append("company_id", companyId)
        formData.append("search_term",searchString)


        const options = {
          method: 'POST',
          url: '/TransactiSellerProducts/getProductsForAutoSuggest.json',
          data: formData
        }
        const response = await axios(options)
          .then(res => {
            
            const products = res.data.products
            if(products.length <= 0){
              setAutoCompleteSearchOptionMessage("No record found.")
              setAutoSuggestProducts([])
            }else{
              setAutoSuggestProducts(products)
            }
           
          }).catch(error => {
    
            
    
          })
      }
      loadProducts()

    
  }
  function getInputtedInventories(product,temporaryInventoryJSON){
    const productInTempStorage = temporaryInventoryJSON.find((productParam) => productParam.code == product.code);
    const inputtedInventories = productInTempStorage && productInTempStorage.InputtedInventories ? productInTempStorage.InputtedInventories : []
    return inputtedInventories

  }

  function uploadInventoryDialog(){
    return(
      <Dialog fullWidth={true} maxWidth={'md'} open={showInventoryDialog} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle>Upload Inventory</DialogTitle>
        <DialogContent>
        <Box p={1} display="flex" justifyContent="left"  flexDirection="column">
          <i>
            1. Product code is required <br/>
            2. Uom is required <br/>
            3. Quantity is required and must be a number <br/>
            4. Expiry Date must be in YYYY-MM-DD format
          </i> <br/>
          <input accept=".csv" type="file" onChange={onInputChange} />
        </Box>
        </DialogContent>
        <DialogActions>
          <Stack direction="row" spacing={1}>
              <Button variant="contained" component="label" onClick={() => {processUploadInventoryCsv(csvFile)}} ><FileUploadIcon /> Upload</Button>
              <Button variant="contained" component="label" onClick={() =>(downloadTemplate)()} ><FileDownloadIcon /> CSV</Button>
              <Button onClick={()=>{setShowInventoryDialog(false)}} variant="contained"  >Close</Button>
          </Stack>
        </DialogActions>
      </Dialog>
    )
  }

  function downloadTemplate(){

    let header = '';
    let filename = '';

    filename = 'Inventory masterfile.csv';
    header = 'Product Code*,Product Name,UOM*,Quantity*,Lot Number,Expiry date';
    const url = 'data:text/csv;charset=utf-8,' + encodeURIComponent(header);
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    link.remove()
  }
  
  function processUploadInventoryCsv(csvFile){
    let file = csvFile[0];
    let headersChecked = false; 
    if(file !== undefined && file.type === "text/csv"){
      Papa.parse(file, {
        header: true,
        skipEmptyLines : true,
        complete: function(results) {

          if (results.data.length === 0) {
            return alert('CSV File cannot be empty.');
          }
          
          if(!headersChecked){
            let keys = [];
            Object.keys(results.data[0]).forEach(value =>{
              keys.push(value);
            });
          
            if(keys.includes('Product Code*') && keys.includes('Product Name') && keys.includes('UOM*') && keys.includes('Quantity*') && keys.includes('Lot Number') && keys.includes('Expiry date') ) {
                headersChecked = true;
            } else{
                alert('File Error. Please Check your headers');
            }
          }
          
          if(headersChecked){

            let chunkedData = chunkUploadData(results.data);
            console.log(chunkedData)
            let totalData = Math.ceil(results.data.length / 10);
            if(chunkedData.length > 0){
              setShowUploadInventoryDialog(false);
              insertInventory(0,chunkedData,totalData);
              setShowUploadInventoryStatusDialog(true);
              
              setShowUploadInventoryDialog(false);
            }else{
              alert('No data to upload');
            }
          }
        }
      });
    }else{
      alert('File error. Please check your file or if a file was selected.');
    }
  }

  function chunkUploadData(results){
    let chunkedData = [];
    let dataArray = [];
    for(let i = 0; i < results.length; i++){
      if(dataArray.length === 10){
        chunkedData.push(dataArray);
        dataArray = [];
      }

      dataArray.push(results[i]);
   
      if ( i === results.length - 1 )
      {
        chunkedData.push(dataArray);
        dataArray = [];
      }
    }
    return chunkedData;
  } 
  
  
  async function insertInventory(index, chunkedData, totalData){
    let percent = (index / totalData) * 100;
    setCsvUploadPercent(percent);
    if(index < chunkedData.length){
      var data = JSON.stringify(chunkedData[index]);

      console.log(data);
      await axios({
        method: 'POST',
        url: '/TransactiSellerProducts/uploadInventory.json',
        data: objectToFormData({index:index, data:data, limitInventoryUpload:limitInventoryUpload})
      }).then((res) =>{
        let res_status = res.data.response.error_msg;
        setUploadStatusArray(uploadStatusArray => [...uploadStatusArray, ...res_status]);

        //Settings Validation
        if(res_status[0] === 'Product upload is not allowed.' || res_status[0] === 'Product upload limit reached.'){
          return;
        }else{
          insertInventory(index+1, chunkedData, totalData);
        }
      });
    }
  }
  
  const uploadInventorytatusDialog = () => {
    
    return(
      <Dialog fullWidth={true} maxWidth={'md'} open={showUploadInventoryStatusDialog} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle>Upload Inventory</DialogTitle>
        <DialogContent>
        <Typography variant="body1">{csvUploadPercent} %</Typography>
          <LinearProgress sx={{height: 10}} variant="determinate" value={csvUploadPercent} />
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 500 }} aria-label="caption table" id="status_tbl">
              <TableHead>
                <TableRow>
                  <TableCell align="left"><b>Line</b></TableCell>
                  <TableCell><b>Message</b></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {uploadStatusArray.map((value, index)=> (
                    <TableRow key={index}>  
                      <TableCell align="left" component="th" scope="row"><b>{index+1}</b></TableCell>
                      <TableCell>{value}</TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{closeUploadStatusDialog()}} color="primary" autoFocus>Close</Button>
        </DialogActions>
      </Dialog>
    )
  }

  
  function closeUploadStatusDialog(){
    setProducts([])
    setLoadProducts(true)

    
    setShowInventoryDialog(false)
    setShowUploadInventoryDialog(false);
    setShowUploadInventoryStatusDialog(false);
    setUploadStatusArray([]);
    setCsvUploadPercent(0)
  }
  
  const objectToFormData = (object) => Object.keys(object).reduce((formData, key) => {
    formData.append(key, object[key]);
    return formData;
  }, new FormData());


  const onInputChange = (event) =>{
    let file = event.target.files;
    setCsvFile(file);
  };

  function uploadInventory()
  {
    setShowInventoryDialog(true)
    menuHandleClose();
  }

  const menuHandleClose = () => {
    setMenuAnchorEl(null)
  };

  function mainBody() {
    return (
      <React.Fragment>
        <Paper square className={classes.productListPaper}>
          {search()}
          {isLoading ? <LinearProgress color="secondary"  style={{marginLeft:'.1rem',marginRight:'.1rem'}}/> : ''}
          {productLists()}
        </Paper>
        <AppBar
          position="fixed"
          color="primary"
          className={classes.appBarBottom}>
           {isLoading ? <LinearProgress color="secondary"  style={{marginLeft:'.1rem',marginRight:'.1rem'}}/> : ''}
          <Toolbar>
            <div className={classes.grow} />

            <Button
              variant="contained"
              onClick={() => {
                if(totalProductCountWithInventoryInputted() <=0){
                  alert("Please input inventory")
                  return
                }
                setOpenInventoryProductsReview(true);
              }}
            >
              <Typography variant="caption">Review Inventory</Typography>
              <Badge
                badgeContent={totalProductCountWithInventoryInputted()}
                color="secondary"
                style={{ marginLeft: "1rem" }}
              />
            </Button>
          </Toolbar>
        </AppBar>
       
        {openInventoryProductsReview ? (
          <InventoryReview
            openInventoryProductsReview={openInventoryProductsReview}
            setOpenInventoryProductsReview={setOpenInventoryProductsReview}
            setOpenReturnInformationReview={setOpenReturnInformationReview}
          />
        ) : (
          ""
        )}
        {openReturnInformationReview ? (
          
              <InventoryInformation
                openReturnInformationReview={openReturnInformationReview}
                setOpenReturnInformationReview={setOpenReturnInformationReview}
                closeAllDialog={closeAllDialog}
              />
         
        ) : (
          ""
        )}
      {openInventoryAddLotNumberAndExpiration ? 
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={materialTheme}>
          <InputInventoryDialog 
           onProductInputtedInventory={onProductInputtedInventory}
            companyId={companyId}
            selectedProduct={selectedProduct}
            openInventoryAddLotNumberAndExpiration ={openInventoryAddLotNumberAndExpiration} 
            setOpenInventoryAddLotNumberAndExpiration={setOpenInventoryAddLotNumberAndExpiration}/>
         </ThemeProvider>
        </StyledEngineProvider>
        :""
      }
       <StyledEngineProvider injectFirst>
          <ThemeProvider theme={materialTheme}> {uploadInventoryDialog()}</ThemeProvider>
          <ThemeProvider theme={materialTheme}> {uploadInventorytatusDialog()}</ThemeProvider>
      </StyledEngineProvider>
        
      
      </React.Fragment>
    );
  }

  return (
    <div>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>  <Toolbar sx={{ justifyContent: 'space-between' }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={props.handleDrawerToggle}
            className={classes.menuButton}
            size="large">
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            Record Inventory
          </Typography>
          <IconButton className={classes.margin} onClick={menuHandleClick} edge="end"><MoreVertIcon/></IconButton>
          <Menu id="simple-menu" open={openMenu} anchorEl={menuAnchorEl} onClose={()=>{setMenuAnchorEl(null)}}> 
            <MenuItem onClick={uploadInventory} >Upload Inventory</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      {mainBody()}
    </div>
  );
}
